import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";
import { Coins, ArrowRight } from "@phosphor-icons/react";

export const TokenBanner = () => {
  const { user } = useAuth();
  const t = useT();
  const nav = useNavigate();
  if (!user || (user.tokens_balance ?? 0) > 0) return null;

  return (
    <div
      data-testid="tokens-zero-banner"
      className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 rounded-lg border border-gold/40 bg-gold/10 px-5 py-4"
    >
      <div className="flex items-center gap-3 flex-1">
        <span className="shrink-0 grid place-items-center w-9 h-9 rounded-md bg-gold/20">
          <Coins weight="fill" size={20} className="text-gold" />
        </span>
        <p className="text-sm font-semibold text-foreground">{t("banner.tokensZero")}</p>
      </div>
      <button
        type="button"
        onClick={() => nav("/billing")}
        data-testid="tokens-zero-banner-cta"
        className="group inline-flex items-center justify-center gap-2 rounded-md bg-gold px-4 py-2 text-sm font-bold text-background transition-colors hover:bg-gold/90"
      >
        {t("banner.tokensZeroCta")}
        <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-0.5" />
      </button>
    </div>
  );
};
